/**
 * transforms and formats people group error
 * @param  {Array} error
 * @return {Object}
 */
export const transformPeopleGroupError = (error) => {
  return error?.promptErrors || error || [];
};
